import { render, staticRenderFns } from "./PostSociety.vue?vue&type=template&id=1bcc3121&scoped=true&"
import script from "./PostSociety.vue?vue&type=script&lang=js&"
export * from "./PostSociety.vue?vue&type=script&lang=js&"
import style0 from "./PostSociety.vue?vue&type=style&index=0&id=1bcc3121&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcc3121",
  null
  
)

export default component.exports